import { Tooltip } from "@mui/material";
import React from "react";
import styled from "styled-components";

import PathArrowSvg from "../../../assets/images/icons/path_arrow.svg";
import PathLineSvg from "../../../assets/images/icons/path_line.svg";
import { FlowConstants } from "../../../rule-engine-core/Flow/Utilities/FlowConstants";
import { FlowStepData } from "../../../rule-engine-core/Flow/Steps/FlowStepData";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export const StepConnectSection = styled.div<{ setMinHeight?: boolean }>`
    display: flex;
    flex-direction: row;
    ${(props) =>
        props.setMinHeight &&
        `
		min-height: 10px;
	`}
`;

export const StepConnect = styled.div`
    display: flex;
    position: relative;
    width: 100%;
`;

export const StepConnectImageDiv = styled.div<{ height?: number }>`
    margin-top: 4px;
    margin-bottom: 4px;
    margin-left: 18px;
    margin-right: 10px;

    display: flex;
    align-items: flex-end;

    min-height: ${(props) => props.height || 8}px;
    width: 8px;
    min-width: 8px;
    max-width: 8px;

    background-image: url(${PathLineSvg});
    background-size: 100% auto;

    position: relative;
`;

export const StepConnectOtherPaths = styled.div`
    flex-direction: column;
    justify-content: space-around;
    display: flex;

    top: 0;
    right: -10px;
    position: absolute;
    height: 100%;
`;

const RegularStepPathTitleDiv = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 140%;

    color: ${FlowConstants.NEXT_STEP_PATH_TITLE_COLOR};
    text-transform: capitalize;

    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;

    &:hover {
        color: ${UIStyleConstants.GREEN_COLOR};
    }
`;

interface RegularStepPathProps {
    title?: string;
    tooltipTitle?: string;
    renderUI?: () => React.ReactNode;
    onTitleClick?: (element: HTMLElement) => void;
    step: FlowStepData;
}

export const RenderStepPath: React.FC<RegularStepPathProps> = (props: RegularStepPathProps) => {
    const PathWithLabel = (
        <>
            <StepConnectImageDiv height={props.title || props.renderUI ? 24 : undefined}>
                <img
                    src={PathArrowSvg}
                    width={8}
                    height={5}
                    alt="Path"
                />
            </StepConnectImageDiv>
            {props.title && (
                <Tooltip title={props.tooltipTitle!}>
                    <RegularStepPathTitleDiv
                        onClick={(event: React.MouseEvent<HTMLDivElement>) => props.onTitleClick!(event.currentTarget)}
                    >
                        {props.title}
                    </RegularStepPathTitleDiv>
                </Tooltip>
            )}
        </>
    );

    return (
        <StepConnect data-testid={`step_${props.step._id}_connect`}>
            {PathWithLabel}

            {props.renderUI && props.renderUI()}
        </StepConnect>
    );
};
